import {
  useContext,
  createContext,
  useEffect,
  useState,
  useCallback,
  useMemo
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "services/api";

const ERROR_CONTEXT = "preview";

export const PreviewContext = createContext({});
export const usePreviewContext = () =>
  useContext(PreviewContext);

export const PreviewContextProvider = ({ children }) => {
  // This token is an encoded property id and timestamp generated in Airbase and decoded in core-api.
  const { bookingToken: propertyIdAndTimestampToken } =
    useParams();

  const navigate = useNavigate();
  const [property, setProperty] = useState({});

  const getPropertyInfo = useCallback(() => {
    api
      .get(
        `/v1/guests/property/${propertyIdAndTimestampToken}`
      )
      .then(res => {
        setProperty(res);
      })
      .catch(err => {
        navigate("/error", {
          state: {
            errorMessage: err.message,
            context: ERROR_CONTEXT
          }
        });
      });
  }, [propertyIdAndTimestampToken]);

  useEffect(() => {
    getPropertyInfo();
  }, []);

  const contextValue = useMemo(
    () => ({
      property
    }),
    [property]
  );

  return (
    <PreviewContext.Provider value={contextValue}>
      {children}
    </PreviewContext.Provider>
  );
};
